import { useContext } from 'react'

import { HeadersContext } from '../../../HeadersContext'
import { usePageProps } from '../../../usePageProps'
import { getUserFreeMembership } from '../../../utils/get-user-session-permissions'

type Params = {
  articleFreeMembershipStatus: string | null
}

export const useShouldShowFreeMembershipBadge = ({
  articleFreeMembershipStatus,
}: Params): boolean => {
  const { userAccessState } = usePageProps()

  const { cookies } = useContext(HeadersContext)
  const isFreeMembership = getUserFreeMembership(cookies ?? '')

  return (
    (articleFreeMembershipStatus === 'lock' || articleFreeMembershipStatus === 'lockContent') &&
    (userAccessState?.userLoggedIn !== true || isFreeMembership)
  )
}
